import {
  IAstOptions,
  getSpecialTokens as IGetSpecialTokens,
  getTokens as IGetTokens
} from '../index.d';
import { IDeclaration } from '../../editor/index.d';
import { generateTokens, validatePatchTokens } from './index';
import { IModelFieldToken, IFqnToken, IDeclarationToken, ICustomPropertyToken } from '../typings/token';


// 获取表达式中用到的 特殊令牌 集合
export const getSpecialTokens: typeof IGetSpecialTokens = (input: string, options: IAstOptions) => {
  const tokens = generateTokens(input, options);
  validatePatchTokens(tokens, options);

  // 自定义属性集合
  const customProperties = tokens.filter(token => {
    return token.type === 'CustomProperty';
  }).map(token => (token as ICustomPropertyToken).property as any);


  const availablePointAccountIds = (options.pointAccounts || []).map(v => v.id);
  const availableGradeHierarchyIds = (options.gradeHierarchies || []).map(v => v.id);

  // 积分账户 集合
  const pointAccounts = !availablePointAccountIds ? [] :
    tokens.filter(token => {

      const { declaration, value, isDeclaration } = token as IDeclarationToken;

      return (isDeclaration
        && declaration === 'CURRENT_MEMBER_POINT'
        && availablePointAccountIds.includes(Number(value))
      );
    }).map(token => (token as IDeclarationToken).value);

  // 等级体系 集合
  const gradeHierarchies = !availableGradeHierarchyIds ? [] :
    tokens.filter(token => {

      const { declaration, isDeclaration, value } = token as IDeclarationToken;

      return (isDeclaration
        && declaration === 'CURRENT_MEMBER_GRADE'
        && availableGradeHierarchyIds.includes(Number(value))
      );
    }).map(token => (token as IDeclarationToken).value);


  // 模型属性集合
  const modelProperties = tokens.filter(token => {
    return token.type === 'ModelProperty';
  }).map((token) => {
    const { model, path, raw, field } = token as IModelFieldToken;
    return { model, path, raw, type: field };
  });

  // 主模型属性集合
  const fqnProperties = tokens.filter(token => {
    return token.type === 'FqnProperty';
  }).map((token) => {
    const { raw, dsl, fqn } = token as IFqnToken;
    return { path: raw, raw, dsl, type: fqn };
  });

  return { customProperties, pointAccounts, gradeHierarchies, modelProperties, fqnProperties };
};


export const getTokens: typeof IGetTokens = (input: string, options?: {
  ignoreWhiteSpace?: boolean,
  declarations?: IDeclaration[],
  fqn?: IAstOptions['fqn']
}) => {
  options = options || {};
  const declarations = options.declarations ? options.declarations :
    ['Id', 'Date', 'Time', 'DateTime', 'Email', 'CURRENT_MEMBER_POINT', 'CURRENT_MEMBER_GRADE'];


  const tokens = generateTokens(input, {
    declarations,
    functions: [],
    fqn: options.fqn
  }, options.ignoreWhiteSpace);


  // 自定义属性集合
  const customProperties = tokens.filter(token => {
    return token.type === 'CustomProperty';
  }).map(token => (token as ICustomPropertyToken).property);


  // 积分账户 集合
  const pointAccounts = tokens.filter((token) => {
    const { declaration, isDeclaration } = token as IDeclarationToken;
    return (isDeclaration && declaration === 'CURRENT_MEMBER_POINT');
  }).map(token => (token as IDeclarationToken).value);


  // 等级体系 集合
  const gradeHierarchies = tokens.filter(token => {
    const { declaration, isDeclaration } = token as IDeclarationToken;
    return (isDeclaration && declaration === 'CURRENT_MEMBER_GRADE');
  }).map(token => (token as IDeclarationToken).value);


  // 模型属性集合
  const modelProperties = tokens.filter(token => {
    return token.type === 'ModelProperty';
  }).map((token) => {
    const { model, path } = token as IModelFieldToken;
    return { model, path };
  });

  // 主模型属性集合
  const fqnProperties = tokens.filter(token => {
    return token.type === 'FqnProperty';
  }).map((token) => {
    const { raw, dsl } = token as IFqnToken;
    return { path: raw, dsl };
  });

  return { customProperties, pointAccounts, gradeHierarchies, modelProperties, fqnProperties, tokens };
};
